import { ButtonSkeleton, TableSkeleton } from '@/components/shared/skeleton'

import { FixedBottomDrawerButton } from '../../FixedBottomDrawerButton'

const UserAutosHeaderSkeleton = () => (
  <div className="flex items-center gap-8">
    <ButtonSkeleton className="h-40 w-40 sm:h-28 sm:w-28" />
    <ButtonSkeleton className="h-40 w-[171px] sm:h-28 sm:w-[120px]" />
  </div>
)

const UserAutosListSkeleton = () => (
  <>
    <div className="mb-[120px] px-40 pb-40 pt-16 lg:px-24 lg:pb-24 lg:pt-0 sm:px-16 sm:pb-20">
      <TableSkeleton
        rows={5}
        itemClassName="mb-12 h-[68px] rounded-12 sm:mb-8"
      />
    </div>

    <FixedBottomDrawerButton>
      <ButtonSkeleton className="h-56 w-full rounded-12 sm:h-44" />
    </FixedBottomDrawerButton>
  </>
)

export { UserAutosHeaderSkeleton, UserAutosListSkeleton }
